/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import BurgerIcon from './components/BurgerIcon';

import t from '../../../../../../../../css/global.module.css';
import s from './navMenuButton.module.css';


const NavMenuButton = ({ labels, isOpen, onClick, onHoverIn, onHoverOut }) => (
  <div
    className={`${s.container} ${t['items-center']} ${t.flex} ${t.pointer}`}
    onMouseEnter={onHoverIn}
    onMouseLeave={onHoverOut}
    onClick={onClick}
    data-qa="navigationButton"
  >
    <div role="button" className={`${s.root} ${t.flex} ${t['near-black']} ${t.pointer}`}>
      <BurgerIcon isOpen={isOpen} width={23} height={20} />
      <span className={`${s.label} ${isOpen ? s.wrapperClose : s.wrapperOpen} ${t['helper_hide-BelowDesktop']} ${t.nowrap}`}>
        <span className={s.labelClose}>{labels.close}</span>
        <span className={s.labelOpen}>{labels.large}</span>
      </span>
      <span className={`${s.label} ${t['helper_show-BelowDesktop']} ${t.nowrap}`}>
        {isOpen ? labels.close : labels.small}
      </span>
    </div>
  </div>
);

NavMenuButton.propTypes = {
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  onHoverIn: PropTypes.func,
  onHoverOut: PropTypes.func,
};

NavMenuButton.defaultProps = {
  onClick: null,
  onHoverIn: null,
  onHoverOut: null,
};

export default NavMenuButton;
